/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState, useEffect} from 'react'
import SearchableSelect from '../SearchableSelect/SearchableSelect'
import {getLokacijePaketaDropdown} from '../../api'
import {Option} from '../../models/Sektor'

// lokacijeRepromaterijala Props for the component
interface DropdownProps {
  value?: string | number
  initialValue?: string | number
  onChange?: (name: string, value: any) => void
  errors?: string | undefined
  touched?: boolean
  selectName?: string
}

const LokacijePaketaDropdown: React.FC<DropdownProps> = ({
  value,
  initialValue,
  onChange,
  errors,
  touched,
  selectName,
}) => {
  const [lokacijeRepromaterijalaDropdown, setLokacijeRepromaterijalaDropdown] = useState<
    Array<Option>
  >([])
  const internalValue = initialValue ?? null

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getLokacijePaketaDropdown()
        setLokacijeRepromaterijalaDropdown(mapData(response.data['data']))
      } catch (error) {
        console.error('Error fetching Povrsinska Struktura dropdown data:', error)
      }
    }
    fetchData()
  }, [])

  const finalValue = value ?? internalValue

  const mapData = (data) => {
    if (!data) {
      return []
    }
    return data.map((item) => ({label: item.Naziv, value: item.Id.toString()}))
  }

  return (
    <SearchableSelect
      options={lokacijeRepromaterijalaDropdown}
      value={finalValue?.toString() ?? ''}
      onChange={onChange!}
      name={selectName ?? 'lokacije paketa Dropdown'}
      errors={errors}
      placeholder='Odaberi Lokaciju Paketa.'
      touched={touched}
    />
  )
}

export default LokacijePaketaDropdown
